import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAsyncRequestManagerListRequestsResult = objectOf({
  position_in_queue: maybe(number, true),
  total_requests_count: number,
  requests: arrayOf(
    objectOf({
      request_id: string,
      estimated_time_remaining: maybe(number, true),
      progress_percentage: number,
      initiator_email: maybe(string),
      app_group_id: maybe(string),
      segment_id: maybe(string),
      segment_name: maybe(string),
    })
  ),
});
